module.exports = __webpack_public_path__ + "assets/logout-cover.png?v=9ef4096ae609d580850cda727fbb10ed";